import {
  consumeSessionNoticeCookie,
  clearSessionNoticeHandled,
  forgetSessionSeen,
  isLoggedInByCookie,
  markSessionNoticeHandled,
  normalizeSessionNotice,
  rememberSessionSeen
} from '@/services/sso'

const initialLoggedIn = isLoggedInByCookie()
const initialSessionNotice = consumeSessionNoticeCookie()

if (initialLoggedIn) {
  rememberSessionSeen()
}

const state = {
  loggedIn: initialLoggedIn,
  sessionNotice: initialSessionNotice
}

const getters = {
  LoggedIn: state => state.loggedIn,
  SessionNotice: state => state.sessionNotice
}

const actions = {
  setLoggedIn ({commit}, data) {
    commit('setLoggedIn', data)
  },
  showSessionNotice ({commit}, reason) {
    commit('setSessionNotice', reason)
  },
  dismissSessionNotice ({commit}) {
    commit('setSessionNotice', null)
  }
}

const mutations = {
  setLoggedIn (state, data) {
    state.loggedIn = data
    if (data) {
      clearSessionNoticeHandled()
      rememberSessionSeen()
    } else {
      forgetSessionSeen()
    }
  },
  setSessionNotice (state, reason) {
    const normalizedReason = normalizeSessionNotice(reason)
    state.sessionNotice = normalizedReason
    if (normalizedReason) {
      markSessionNoticeHandled()
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
